import { FedevAuthService } from '@bmw-fedev/auth';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { recoverSession } from './session-recovery';

const SESSION_EXPIRED_EVENTS = new Set<string>([
  'silent_refresh_error',
  'token_refresh_error',
]);

export const restartLoginOnSessionExpiry = (
  authSvc: FedevAuthService,
  router: Router
): void => {
  authSvc.events$
    .pipe(filter((event) => SESSION_EXPIRED_EVENTS.has(event.type)))
    .subscribe(() => {
      const returnUrl =
        globalThis.location.pathname + globalThis.location.search;
      recoverSession(authSvc, router, returnUrl);
    });
};
